import { AppModule } from './app.module';
import { enableProdMode } from '@angular/core';
import { ENVIRONMENT } from '../../environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { TrackJS } from 'trackjs';

TrackJS.install(ENVIRONMENT.TrackJS);

enableProdMode();
platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/app/main.ts